import {
  AccessToken,
  LoginAnonymouslyRequestModel,
} from "../../../domain/model/Auth";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { AuthRepository } from "./AuthRepository";

export class AuthRepositoryImpl implements AuthRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }

  loginAnonymously(
    body: LoginAnonymouslyRequestModel,
  ): Promise<Response<AccessToken>> {
    return this.apiService.loginAnonymously(body);
  }
}
